module.exports = __webpack_public_path__ + "img/cover2.48c09c80.png";